import React from "react";

const ConfigPaudSmpMTsPaketB = {
    Apk: {
        title: "APK SMA/SMK/PAKET C",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 16-18',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp11618_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp11618_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp11618_jumlah',
                    },
                ]
            },
        ]
    },
    Apm: {
        title: "APM SMA/SMK/PAKET C",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 16-18',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp11618_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp11618_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp11618_jumlah',
                    },
                ]
            },
        ]
    }
}

export default ConfigPaudSmpMTsPaketB;